<script lang="ts">
    import {writable} from 'svelte/store';
    import Modal, {bind} from "svelte-simple-modal";
    import Content from "./Content.svelte";
    import {setupI18n, isLocaleLoaded} from './services/i18n.js';
    import {onMount} from "svelte";
    import TestModal from "./components/modal/TestModal.svelte";

    declare var lang: string; //this is specified in the index.html file to change the language

    $: if (!$isLocaleLoaded) {
        setupI18n({withLocale: lang});
    }
    //use this for all translations: {$_('stepContent.dragFileHere')}
/*
    onMount(async () => {
        const svelteSimpleModal = await import('svelte-simple-modal');
        Modal = svelteSimpleModal.default;
    });
    */

    import {ModalBody} from "carbon-components-svelte";

</script>
<!--
<svelte:head>
    <link
            rel="stylesheet"
            href="https://unpkg.com/carbon-components-svelte/css/white.css"
    />
</svelte:head>
-->

<svelte:options immutable={true}/>
{#if $isLocaleLoaded}
    <Content />
{/if}
